export const addQueryParams = (path: string, query: Record<string, unknown>) => {
    if (!Object.keys(query).length) {
        return path;
    }

    const separator = path.includes('?') ? '&' : '?';

    const queryString = Object.entries(query)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return path + separator + queryString;
};
